module.exports = __webpack_public_path__ + "img/syl_detail.4fc49fc3.jpg";